'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractDate = exports.getUtcDate = exports.getDate = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a new date object for the given day, month, and year in local time zone
 * @param day the day you wish this object to represent
 * @param month the numeric value of the month
 * @param year the full four digit value of the year
 * @returns A date object corresponding to the new day, month, and year
 */
var getDate = exports.getDate = function getDate(day, month, year) {
  return (0, _moment2.default)({ year: year, month: month, day: day });
};

/**
 * Creates a new date object for the given day, month, and year in UTC
 * @param day the day you wish this object to represent
 * @param month the numeric value of the month
 * @param year the full four digit value of the year
 * @returns A date object corresponding to the new day, month, and year
 */
var getUtcDate = exports.getUtcDate = function getUtcDate(day, month, year) {
  return _moment2.default.utc({ year: year, month: month, day: day });
};

var extractDate = exports.extractDate = function extractDate(date, isDateTime) {
  return isDateTime ? (0, _moment2.default)(date).format('YYYY-MM-DD') : _moment2.default.utc(date).format('YYYY-MM-DD');
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/utils/DateUtils.js
// module id = 152
// module chunks = 10